import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

// components
import Faqs from "elements/Faqs";
import BottomBanner from "elements/BottomBanner";
import LandingBanner from "elements/LandingBanner";
import PopularGameSlider from "elements/games_elements/PopularGameSlider";
import WelcomePromotions from "elements/WelcomePromotions";
import PromotionSlider from "elements/PromotionSlider";
import GameSlider from "elements/games_elements/GameSlider";
// import SingleCategoryGames from "elements/games_elements/SingleCategoryGames";
import Winner from "elements/Winner";

import { __ } from "services/Translator";
import swal from "sweetalert";

export default function Landing(props) {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/account-activated") {
      swal({
        title: __("Successfully Activated"),
        // text: __(
        //   "A password recovery email has been sent to your provided email address."
        // ),
        icon: "success",
      });
    }
  }, [location.pathname]);

  return (
    <>
      <div className="joker_landing_page">
        <LandingBanner {...props} />
        <PopularGameSlider {...props} />

        <div className="container-xxl container-xl">
          <GameSlider
            categoryName="Popular"
            category="popular"
            perPage="20"
            {...props}
          />

          <GameSlider
            categoryName="Live Casino"
            category="live_casino"
            perPage="20"
            {...props}
          />
        </div>
        <PromotionSlider {...props} />

        {!props.isMobileDevice && <WelcomePromotions {...props} />}

        <BottomBanner {...props} />
        <div className="container-xxl container-xl">
          <Winner {...props} />
        </div>
        {/* {!props.isMobileDevice && <Faqs {...props} />} */}
      </div>
    </>
  );
}
